/* src/app/private/components/view/orgnaization-config/orgnaization-config.component.scss */
/*# sourceMappingURL=orgnaization-config.component.css.map */
